import DayNight from '../classes/DayNight.js';
import Untreated from '../classes/Untreated.js';


function init () {
	const elDayNightContainer = document.querySelector('.day-night-container');
	if (elDayNightContainer) {
		new DayNight(elDayNightContainer);
	}
	const elUntreatedContainer = document.querySelector('.untreated-container');
	if (elUntreatedContainer) {
		new Untreated(elUntreatedContainer);
	}
}

const module = () => {
    if (document.readyState === 'complete' || document.readyState === 'loaded') {
		/* If document is already loaded, start */
		init();
	} else {
		/* Else, wait for domLoaded event */
		document.addEventListener('DOMContentLoaded', init);
	}
};

export default module;